/* eslint-disable */
import {
	Button,
	Dialog,
	DialogContent,
	DialogTitle,
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Paper,
	Select,
	TextField,
	Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { getArmazonesAnteojosSol } from "../../../project/services/ArticuloService";
import { getCacheData } from "../../services/CacheService";
import Message from "../../../project/utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";

const initialSearchData = {
	tipoArticulo: "AR",
	codigo: "",
	descripcion: "",
	arAsMarca: "",
	arAsModelo: "",
	arAsCategoria: "",
	arAsMaterial: "",
	arAsFormato: "",
	arAsCalibre: "",
	arAsTipo: "",
	disponibleObraSocial: "T",
	precioVentaDesde: 0,
	precioVentaHasta: 0,
};

const tipoArticulo = [
	{
		id: "T",
		descripcion: "Armazones y Anteojos de Sol",
	},
	{
		id: "AR",
		descripcion: "Solo Armazones",
	},
	{
		id: "AS",
		descripcion: "Solo Anteojos de Sol",
	},
];

const disponibleObraSocial = [
	{
		id: "T",
		descripcion: "Todos",
	},
	{
		id: "S",
		descripcion: "Sí",
	},
	{
		id: "N",
		descripcion: "No",
	},
];
//
// ################################################################################
//
const BuscarArmazonAnteojoSolDialog = ({ open, onClose, onSelect }) => {
	const [searchData, setSearchData] = useState(initialSearchData);
	const [articulos, setArticulos] = useState([]);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [arAsMarcas, setArAsMarcas] = useState([]);
	const [arAsCategorias, setArAsCategorias] = useState([]);
	const [arAsMateriales, setArAsMateriales] = useState([]);
	const [arAsFormatos, setArAsFormatos] = useState([]);
	const [arAsCalibres, setArAsCalibres] = useState([]);
	const [arAsTipos, setArAsTipos] = useState([]);

	const tableColumns = [
		{
			field: "tipo_articulo",
			headerName: "Tipo",
			headerAlign: "center",
			align: "left",
			flex: 1,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.tipo_articulo;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "codigo",
			headerName: "Código",
			headerAlign: "center",
			align: "center",
			flex: 1,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.codigo;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "descripcion",
			headerName: "Descripción",
			headerAlign: "center",
			align: "left",
			flex: 3,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.descripcion;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "descripcion_ar_as_marca",
			headerName: "Marca",
			headerAlign: "center",
			align: "left",
			flex: 3,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.descripcion_ar_as_marca;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "modelo",
			headerName: "Modelo",
			headerAlign: "center",
			align: "left",
			flex: 2,
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.modelo;
				_val = _val ? _val.toUpperCase() : "";
				return _val;
			},
		},
		{
			field: "precio_venta_lista",
			headerName: "Prc Venta",
			headerAlign: "center",
			align: "right",
			flex: 1,
			type: "number",
			sortable: false,
			renderCell: (params) => {
				let _val = params.row.precio_venta_lista.toFixed(2);
				_val = _val ? _val : "";
				return _val;
			},
		},
		{
			field: "actions",
			headerName: "Seleccionar",
			headerAlign: "center",
			align: "left",
			flex: 1,
			sortable: false,
			filterable: false,
			renderCell: (params) => (
				<>
					{params.row.cu !== "view" && (
						<Tooltip title="seleccionar">
							<IconButton
								size="small"
								aria-label="update"
								onClick={() => handleRowClick(params.row)}
							>
								<CheckIcon />
							</IconButton>
						</Tooltip>
					)}
				</>
			),
		},
	];

	const handlePaginationModelChange = (newModel) => {
		setCurrentPage(newModel.page);
		setRowsPerPage(newModel.pageSize);
	};

	const tableOptions = {
		paginationMode: "server",
		rowCount: totalRowsCount,
		paginationModel: {
			page: currentPage,
			pageSize: rowsPerPage,
		},
		onPaginationModelChange: handlePaginationModelChange,
		pageSizeOptions: [10, 20, 30],
		disableRowSelectionOnClick: true,
		disableColumnMenu: true,
		disableColumnFilter: true,
		disableColumnSelector: true,
		disableDensitySelector: true,
		localeText: {
			noRowsLabel: "",
			noResultsOverlayLabel: "",
			MuiTablePagination: {
				labelRowsPerPage: "Filas:",
				labelDisplayedRows: ({ from, to, count }) =>
					`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
			},
		},
		sx: {
			"& .MuiDataGrid-cell": {
				fontSize: "0.9em",
			},
			"& .MuiDataGrid-columnHeaders": {
				backgroundColor: "#f5f5f5",
			},
		},
	};
	//
	// ################################################################################
	//
	useEffect(() => {
		loadArAsMarcas();
		loadArAsCategorias();
		loadArAsMateriales();
		loadArAsFormatos();
		loadArAsCalibres();
		loadArAsTipos();
	}, []);
	//
	// ################################################################################
	//
	useEffect(() => {
		load();
	}, [currentPage, rowsPerPage]);
	//
	// ################################################################################
	//
	const loadArAsMarcas = async () => {
		const response = await getCacheData("ar_as_marca")
		if (response.ok) {
			setArAsMarcas(response.data.data);
		} else {
			setArAsMarcas([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsCategorias = async () => {
		const response = await getCacheData("ar_as_categoria")
		if (response.ok) {
			setArAsCategorias(response.data.data);
		} else {
			setArAsCategorias([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsMateriales = async () => {
		const response = await getCacheData("ar_as_material")
		if (response.ok) {
			setArAsMateriales(response.data.data);
		} else {
			setArAsMateriales([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsFormatos = async () => {
		const response = await getCacheData("ar_as_formato")
		if (response.ok) {
			setArAsFormatos(response.data.data);
		} else {
			setArAsFormatos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsCalibres = async () => {
		const response = await getCacheData("ar_as_calibre")
		if (response.ok) {
			setArAsCalibres(response.data.data);
		} else {
			setArAsCalibres([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const loadArAsTipos = async () => {
		const response = await getCacheData("ar_as_tipo");
		if (response.ok) {
			setArAsTipos(response.data.data);
		} else {
			setArAsTipos([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]: e.target.value,
		});
	};
	//
	// ################################################################################
	//
	const handleLimpiar = () => {
		setSearchData(initialSearchData);
	};
	//
	// ################################################################################
	//
	const handleBuscar = () => {
		load();
	};
	//
	// ################################################################################
	//
	const load = async () => {
		let _params = {
			arAsCalibre: searchData.arAsCalibre,
			arAsCategoria: searchData.arAsCategoria,
			arAsFormato: searchData.arAsFormato,
			arAsMarca: searchData.arAsMarca,
			arAsMaterial: searchData.arAsMaterial,
			arAsModelo: searchData.arAsModelo,
			arAsTipo: searchData.arAsTipo,
			codigo: searchData.codigo,
			descripcion: searchData.descripcion,
			disponibleObraSocial: searchData.disponibleObraSocial,
			precioVentaDesde: searchData.precioVentaDesde,
			precioVentaHasta: searchData.precioVentaHasta,
			tipoArticulo: searchData.tipoArticulo,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		}

		setIsDoingSomething(true);
		const response = await getArmazonesAnteojosSol(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			setTotalRowsCount(response.data.count);
			setArticulos(response.data.data);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};
	//
	// ################################################################################
	//
	const handleRowClick = (parRow) => {
		onSelect(parRow);
	};
	//
	// ################################################################################
	//
	const handleCloseDialog = () => {
		onClose();
	};
	//
	// ################################################################################
	//
	return (
		<>
			<Dialog
				open={open}
				onClose={handleCloseDialog}
				maxWidth="xl"
				fullWidth={true}
				scroll="paper"
				aria-labelledby="form-dialog-title"
			>
				<DialogTitle id="form-dialog-title">
					Búsqueda de Armazones y Anteojos de Sol
					<IconButton
						aria-label="close"
						onClick={onClose}
						sx={{
							position: "absolute",
							right: 8,
							top: 8,
							color: (theme) => theme.palette.grey[500],
						}}
					>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent dividers>
					<Box>
						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12}>
								{/* Tipo de articulo Armazon, Anteojo de Sol, Todos */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="tipo-articulo-select-label">
										Tipo de Artículo
									</InputLabel>
									<Select
										labelId="tipo-articulo-select-label"
										id="tipo-articulo-select"
										name="tipoArticulo"
										value={searchData.tipoArticulo}
										label="Tipo de Artículo"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{tipoArticulo.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Codigo de articulo */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="codigo"
									label="Código"
									value={searchData.codigo}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Descripcion */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="descripcion"
									label="Descripción"
									value={searchData.descripcion}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Marca */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="marca-select-label">Marca</InputLabel>
									<Select
										labelId="marca-select-label"
										id="marca-select"
										name="arAsMarca"
										value={searchData.arAsMarca}
										label="Marca"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsMarcas.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Modelo */}

								<TextField
									sx={{ width: "100%" }}
									variant="outlined"
									size="small"
									name="arAsModelo"
									label="Modelo"
									value={searchData.arAsModelo}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Categoria */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="categoria-select-label">Categoría</InputLabel>
									<Select
										labelId="categoria-select-label"
										id="categoria-select"
										name="arAsCategoria"
										value={searchData.arAsCategoria}
										label="Categoría"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsCategorias.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Material */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="material-select-label">Material</InputLabel>
									<Select
										labelId="material-select-label"
										id="material-select"
										name="arAsMaterial"
										value={searchData.arAsMaterial}
										label="Material"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsMateriales.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Formato */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="formato-select-label">Formato</InputLabel>
									<Select
										labelId="formato-select-label"
										id="formato-select"
										name="arAsFormato"
										value={searchData.arAsFormato}
										label="Formato"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsFormatos.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Calibre */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="calibre-select-label">Calibre</InputLabel>
									<Select
										labelId="calibre-select-label"
										id="calibre-select"
										name="arAsCalibre"
										value={searchData.arAsCalibre}
										label="Calibre"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsCalibres.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.valor}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Tipo */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="tipo-select-label">Tipo</InputLabel>
									<Select
										labelId="tipo-select-label"
										id="tipo-select"
										name="arAsTipo"
										value={searchData.arAsTipo}
										label="Tipo"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{arAsTipos.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>

						<Grid container spacing={1} sx={{ pb: 1 }}>
							<Grid item xs={12} md={4}>
								{/* Disponible para Obra Social */}

								<FormControl fullWidth sx={{ width: "100%" }}>
									<InputLabel id="disponible-os-select-label">
										Disponible para Obras Sociales
									</InputLabel>
									<Select
										labelId="disponible-os-select-label"
										id="disponible-os-select"
										name="disponibleObraSocial"
										value={searchData.disponibleObraSocial}
										label="Disponible para Obras Sociales"
										size="small"
										onChange={handleChange}
										MenuProps={{ style: { maxHeight: "300px" } }}
									>
										{disponibleObraSocial.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Precio de Venta Desde */}

								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-desde"
									size="small"
									name="precioVentaDesde"
									label="Desde precio"
									value={searchData.precioVentaDesde}
									onChange={handleChange}
								/>
							</Grid>
							<Grid item xs={12} md={4}>
								{/* Precio de Venta Hasta */}

								<TextField
									sx={{ width: "100%" }}
									id="precio-venta-hasta"
									size="small"
									name="precioVentaHasta"
									label="Hasta precio"
									value={searchData.precioVentaHasta}
									onChange={handleChange}
								/>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ mb: 1, float: "right" }}>
						<Button
							sx={{ mr: 1 }}
							variant="contained"
							onClick={handleBuscar}
							startIcon={<SearchIcon />}
						>
							Buscar
						</Button>
						<Button
							sx={{ mr: 1 }}
							variant="outlined"
							onClick={handleLimpiar}
							startIcon={<CleaningServicesIcon />}
						>
							Limpiar
						</Button>
					</Box>

					<Paper
						sx={{
							width: "100%",
							overflow: "hidden",
							border: "1px solid LightGrey",
						}}
					>
						<DataGrid
							rows={articulos}
							columns={tableColumns}
							{...tableOptions}
						/>
					</Paper>
				</DialogContent>
			</Dialog>

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}

			<WaitingDialog open={isDoingSomething} />
		</>
	);
};
export default BuscarArmazonAnteojoSolDialog;
